<template>
  <v-container>
    <!--    Heading-->

    <!--    Page-->
    <v-row class="d-flex justify-between align-center mt-16">
      <v-col cols="12" md="6">
        <v-container fluid class="pa-0">
          <!-- Tabs for different steppers -->

          <v-tabs v-model="tab" grow background-color="primary" class="mb-12">
            <v-tabs-slider color="secondary"></v-tabs-slider>
            <v-tab ref="companyData" style="color: white"
              >COMPANY DETAILS</v-tab
            >
            <v-tab ref="bankData" style="color: white">BANKING DETAILS</v-tab>
          </v-tabs>

          <p style="color: white; font-size: 1rem; font-weight: 700">
            <span style="color: yellow">*</span> Kindly fill in the company
            details below…
          </p>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-row v-if="bio">
                <v-col cols="12" class="background-color: primary">
                  <span class="text-uppercase dashboard-register__white"
                    >Company Phone number (Owner)</span
                  >
                  <v-text-field
                    dense
                    rounded
                    filled
                    placeholder="Enter Phone Number"
                    name="company_phone"
                    class="mt-2 mb-2 dashboard-register__custom-textField"
                    v-model="formData.company_phone"
                    :rules="rules.company_phone"
                    ref="company_phone"
                  ></v-text-field>

                  <span class="text-uppercase dashboard-register__white"
                    >Company kra pin</span
                  >
                  <v-text-field
                    dense
                    rounded
                    filled
                    placeholder="Enter KRA Pin"
                    class="mt-2 mb-2 dashboard-register__custom-textField"
                    v-model="formData.kra_pin"
                    name="kra_pin"
                    :rules="rules.kra_pin"
                    ref="kra_pin"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  class="d-flex flex-row justify-space-around background: primary"
                >
                  <v-btn
                    large
                    rounded
                    @click="handleProceed"
                    color="secondary"
                    class="primary--text"
                    style="padding: 0 3rem"
                  >
                    Proceed
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="12" class="background-color: primary">
                  <span class="text-uppercase dashboard-register__white"
                    >Company Bank name</span
                  >
                  <v-text-field
                    dense
                    flat
                    rounded
                    filled
                    placeholder="Enter Bank Name"
                    class="mt-2 mb-2 dashboard-register__custom-textField"
                    v-model="formData.bank_name"
                  ></v-text-field>

                  <span class="text-uppercase dashboard-register__white"
                    >Company Bank Branch</span
                  >
                  <v-text-field
                    rounded
                    filled
                    dense
                    placeholder="Enter Bank Branch"
                    class="mt-2 dashboard-register__custom-textField"
                    v-model="formData.branch_name"
                  ></v-text-field>

                  <span class="text-uppercase dashboard-register__white"
                    >Company Bank Account Name</span
                  >
                  <v-text-field
                    rounded
                    filled
                    dense
                    placeholder="Enter Bank Account Name"
                    class="mt-2 mb-2 dashboard-register__custom-textField"
                    v-model="formData.account_name"
                  ></v-text-field>

                  <span class="text-uppercase dashboard-register__white"
                    >Company Bank Account No.</span
                  >
                  <v-text-field
                    rounded
                    filled
                    dense
                    placeholder="Enter Bank Account No."
                    class="mt-2 mb-2 dashboard-register__custom-textField"
                    v-model="formData.account_number"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  class="d-flex flex-row justify-space-around background-color: primary"
                >
                  <v-btn
                    large
                    rounded
                    @click="$refs.companyData.$el.click()"
                    color="transparent"
                    class="secondary--text"
                    style="padding: 0 3rem; border: 1px solid white !important;"
                  >
                    Back
                  </v-btn>
                  <v-btn
                    large
                    rounded
                    color="secondary"
                    class="primary--text"
                    style="padding: 0 3rem"
                    @click="handleSubmit"
                  >
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-col>
      <v-col cols="5" class="d-none d-md-flex flex-column align-center">
        <v-img
          class="mx-2 mb-16 ml-5"
          src="/img/logo-inverted.png"
          max-width="120"
        ></v-img>
        <v-icon style="font-size: 250px" color="secondary" class="mt-16 mb-16"
          >mdi-briefcase-outline</v-icon
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AuthService } from "../../auth";
export default {
  name: "DashboardRegister",
  data: () => ({
    formData: {
      company_phone: "",
      kra_pin: "",
      bank_name: "",
      branch_name: "",
      account_name: "",
      account_number: ""
    },

    modalLoading: false,
    tab: null,
    bio: true
  }),

  computed: {
    rules() {
      return {
        company_phone: [value => !!value || "Required."],
        kra_pin: [value => !!value || "Required."]
      };
    },

    initialUser() {
      const user = AuthService.getUser();
      let initialData = {
        company_phone: "",
        kra_pin: "",
        bank_name: "",
        branch_name: "",
        account_name: "",
        account_number: ""
      };
      if (user?.bank_details?.bank_name) {
        initialData = {
          company_phone: user?.company_phone || "",
          kra_pin: user?.bank_details?.kra_pin || "",
          bank_name: user?.bank_details?.bank_name || "",
          branch_name: user?.bank_details?.branch_name || "",
          account_name: user?.bank_details?.account_name || "",
          account_number: user?.bank_details?.account_number || ""
        };
      }

      return initialData;
    }
  },

  methods: {
    handleProceed() {
      let isValid = true;

      for (let key in this.rules) {
        isValid = isValid ? this.$refs[key].validate(true) : false;
      }
      if (isValid) {
        this.$refs.bankData.$el.click();
      }
    },

    handleSubmit() {
      const user = AuthService.getUser();
      const data = { ...this.formData };
      data.id = user.id;
      data.name = user.company_name;
      data.email = user.email;

      this.$store.dispatch("Dashboard/updateUserProfile", data);
    },

    init() {
      this.formData = this.initialUser;
    }
  },

  mounted() {
    Event.$on("modalLoading", value => {
      this.modalLoading = value;
    });
  },

  created() {
    this.init();
  }
};
</script>

<style lang="scss">
.theme--light.dashboard-register__custom-textField
  > .v-input__control
  > .v-input__slot {
  background: white !important;
}

.dashboard-register__white {
  color: white;
}
</style>
